import React from "react";
import MainTemplate from "../../../components/MainTemplate/MainTemplate";
import ChurchSubscribersChild from "./ChurchSubscribersChild";

const ChurchSubscribers = () => {
  return (
    <MainTemplate>
      <ChurchSubscribersChild />
    </MainTemplate>
  );
};

export default ChurchSubscribers;
